// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__lI3hX","home":"Breadcrumbs_home__21VUS","separator":"Breadcrumbs_separator__fusj1","current":"Breadcrumbs_current__FFzFf"};